import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMfr = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.23226 3.35925C3.42225 3.1316 3.70348 3 4.00001 3H16C16.5523 3 17 3.44772 17 4V14.8889L18.1006 19.7805C18.1673 20.0769 18.0956 20.3875 17.9059 20.6247C17.7161 20.8619 17.4288 21 17.125 21H4.87501C4.57122 21 4.28391 20.8619 4.09414 20.6247C3.90437 20.3875 3.83271 20.0769 3.8994 19.7805L4.97977 14.9788L3.01614 4.17889C2.96309 3.88715 3.04226 3.58691 3.23226 3.35925ZM6.80001 16L6.12501 19H15.875L15.2 16H6.80001ZM15 14V5H5.19822L6.83458 14H15Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 4C15 3.44772 15.4477 3 16 3H18.4C18.9523 3 19.4 3.44772 19.4 4V6.80952H20C20.5523 6.80952 21 7.25724 21 7.80952V14C21 14.5523 20.5523 15 20 15H16C15.4477 15 15 14.5523 15 14V4ZM19 8.80952H18.4C17.8477 8.80952 17.4 8.36181 17.4 7.80952V5H17V13H19V8.80952Z",
		fill: "currentColor"
	})]
});
export default SvgMfr;
